/* Mosaica Home — shared storefront logic (calculator, product buy box, cart, drawer). */
(function () {
  'use strict';

  var CFG = window.MH_CONFIG || {};
  var ROLL_M2 = CFG.rollM2 || 5.3;
  var WASTE = CFG.waste || 1.1;
  var SHIP_COST = CFG.shipCost != null ? CFG.shipCost : 250;
  var FREE_FROM_ROLLS = CFG.freeFromRolls || 2;

  // Single source of truth for the roll calculator (home, product, mobile).
  function calc(width, height, price) {
    var m2 = width * height;
    var rolls = m2 > 0 ? Math.ceil((m2 * WASTE) / ROLL_M2) : 0;
    var shipping = shippingFor(rolls);
    return { m2: m2, rolls: rolls, shipping: shipping, total: rolls * price + shipping };
  }

  function shippingFor(rolls) {
    return rolls >= FREE_FROM_ROLLS ? 0 : (rolls === 1 ? SHIP_COST : 0);
  }

  function money(n) {
    return '$' + Math.round(n).toLocaleString('es-MX');
  }

  function num(input) {
    var v = parseFloat(String(input.value).replace(',', '.'));
    return isFinite(v) && v > 0 ? v : 0;
  }

  function fmtM2(m2) {
    return m2 > 0 ? m2.toLocaleString('es-MX', { maximumFractionDigits: 1 }) : '0';
  }

  function rollsLabel(n) {
    return n === 1 ? 'rollo' : 'rollos';
  }

  // Shipping notice states shared by product page and cart.
  function setNotice(el, rolls, freeOverride) {
    if (!el) return;
    var free = freeOverride != null ? freeOverride : rolls >= FREE_FROM_ROLLS;
    if (rolls <= 0) {
      el.dataset.state = 'neutral';
      el.textContent = 'Captura las medidas de tu muro para calcular tus rollos.';
    } else if (free) {
      el.dataset.state = 'ok';
      el.textContent = 'Tu envío es gratis. Llega en 5 días hábiles.';
    } else {
      el.dataset.state = 'warn';
      el.textContent = 'Agrega 1 rollo más y el envío es gratis. Con 1 rollo el envío cuesta ' + money(SHIP_COST) + '.';
    }
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.dataset.count = count;
    });
    document.querySelectorAll('[data-cart-count-text]').forEach(function (el) {
      el.textContent = 'Carrito (' + count + ')';
    });
  }

  /* ---------- Home calculator ---------- */
  function initHomeCalc(root) {
    var price = parseFloat(root.dataset.price) || 1200;
    var w = root.querySelector('[data-calc-width]');
    var h = root.querySelector('[data-calc-height]');
    var out = {
      m2: root.querySelector('[data-out-m2]'),
      rolls: root.querySelector('[data-out-rolls]'),
      unit: root.querySelector('[data-out-unit]'),
      sub: root.querySelector('[data-out-subtotal]'),
      ship: root.querySelector('[data-out-shipping]'),
      total: root.querySelector('[data-out-total]'),
      cta: root.querySelector('[data-out-cta]')
    };
    function render() {
      var r = calc(num(w), num(h), price);
      out.m2.textContent = fmtM2(r.m2);
      out.rolls.textContent = r.rolls;
      out.unit.textContent = rollsLabel(r.rolls);
      out.sub.textContent = money(r.rolls * price);
      out.ship.textContent = r.rolls === 0 ? '—' : (r.shipping === 0 ? 'Gratis' : money(r.shipping));
      out.total.textContent = money(r.total);
      // Carry the wall size into the catalog so the product page can prefill it.
      try { if (r.m2 > 0) sessionStorage.setItem('mh-wall', JSON.stringify({ w: num(w), h: num(h) })); } catch (e) {}
    }
    w.addEventListener('input', render);
    h.addEventListener('input', render);
    render();
  }

  /* ---------- Product buy box ---------- */
  function initBuyBox(root) {
    var price = parseFloat(root.dataset.price) || 1200;
    var form = root.querySelector('form');
    var w = root.querySelector('[data-calc-width]');
    var h = root.querySelector('[data-calc-height]');
    var qtyInputs = document.querySelectorAll('[data-qty]');
    var forM2 = root.querySelector('[data-out-m2]');
    var outRolls = root.querySelector('[data-out-rolls]');
    var notice = root.querySelector('[data-notice]');
    var atcLabels = document.querySelectorAll('[data-atc-label]');
    var wallProp = root.querySelector('[data-wall-prop]');
    var error = root.querySelector('[data-error]');
    var touched = false;
    var qty = 1;

    function setQty(n, fromUser) {
      qty = Math.max(1, Math.min(999, Math.floor(n) || 1));
      if (fromUser) touched = true;
      qtyInputs.forEach(function (i) { i.value = qty; });
      atcLabels.forEach(function (el) { el.textContent = el.dataset.prefix + ' · ' + money(qty * price); });
      var measured = num(w) * num(h) > 0;
      setNotice(notice, measured || touched ? qty : 0);
    }

    function onMeasure() {
      var r = calc(num(w), num(h), price);
      forM2.textContent = fmtM2(r.m2);
      outRolls.textContent = r.rolls + ' ' + rollsLabel(r.rolls);
      wallProp.value = r.m2 > 0 ? (num(w).toLocaleString('es-MX') + ' × ' + num(h).toLocaleString('es-MX') + ' m') : '';
      wallProp.disabled = !(r.m2 > 0);
      if (r.rolls > 0) setQty(r.rolls, false); else setQty(qty, false);
      try { if (r.m2 > 0) sessionStorage.setItem('mh-wall', JSON.stringify({ w: num(w), h: num(h) })); } catch (e) {}
    }

    document.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () { setQty(qty + parseInt(btn.dataset.qtyStep, 10), true); });
    });
    qtyInputs.forEach(function (i) {
      i.addEventListener('change', function () { setQty(parseInt(i.value, 10), true); });
    });
    w.addEventListener('input', onMeasure);
    h.addEventListener('input', onMeasure);

    // Prefill from the home calculator if the shopper already measured.
    try {
      var saved = JSON.parse(sessionStorage.getItem('mh-wall') || 'null');
      if (saved && !w.value && !h.value) { w.value = saved.w; h.value = saved.h; }
    } catch (e) {}
    onMeasure();

    function submit(ev) {
      ev.preventDefault();
      var buttons = document.querySelectorAll('[data-atc]');
      buttons.forEach(function (b) { b.disabled = true; });
      error.hidden = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      }).then(function (res) {
        if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || 'Error'); });
        window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
      }).catch(function (err) {
        error.textContent = 'No pudimos agregar al carrito: ' + err.message;
        error.hidden = false;
        buttons.forEach(function (b) { b.disabled = false; });
      });
    }
    form.addEventListener('submit', submit);
    // The mobile sticky bar button lives outside the form; it submits the same form.
    document.querySelectorAll('[data-atc-external]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery(root) {
    var main = root.querySelector('.mh-pdp__main');
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.dataset.src;
        main.srcset = t.dataset.srcset || '';
        main.alt = t.dataset.alt || '';
        root.querySelectorAll('[data-thumb]').forEach(function (o) { o.setAttribute('aria-current', o === t ? 'true' : 'false'); });
      });
    });
  }

  /* ---------- Cart page ---------- */
  function initCart(root) {
    function change(line, quantity) {
      root.classList.add('is-busy');
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function () { window.location.reload(); })
        .catch(function () { root.classList.remove('is-busy'); });
    }
    root.querySelectorAll('[data-line]').forEach(function (row) {
      var line = parseInt(row.dataset.line, 10);
      var input = row.querySelector('[data-line-qty]');
      row.querySelectorAll('[data-line-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          change(line, Math.max(0, parseInt(input.value, 10) + parseInt(b.dataset.lineStep, 10)));
        });
      });
      input.addEventListener('change', function () { change(line, Math.max(0, parseInt(input.value, 10) || 0)); });
      var rm = row.querySelector('[data-line-remove]');
      if (rm) rm.addEventListener('click', function () { change(line, 0); });
    });
  }

  /* ---------- Mobile menu drawer ---------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-drawer]');
    if (!drawer) return;
    var openBtn = document.querySelector('[data-drawer-open]');
    function close() { drawer.classList.remove('is-open'); openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus(); }
    openBtn.addEventListener('click', function () {
      drawer.classList.add('is-open');
      openBtn.setAttribute('aria-expanded', 'true');
      drawer.querySelector('a, button').focus();
    });
    drawer.querySelectorAll('[data-drawer-close], a').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
  }

  /* ---------- Collection "load more" ---------- */
  function initLoadMore(btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var url = btn.getAttribute('href');
      btn.setAttribute('aria-busy', 'true');
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = document.querySelector('[data-grid]');
        doc.querySelectorAll('[data-grid] > *').forEach(function (card) { grid.appendChild(card); });
        var shown = document.querySelector('[data-shown]');
        if (shown) shown.textContent = grid.children.length;
        var next = doc.querySelector('[data-load-more]');
        if (next) { btn.setAttribute('href', next.getAttribute('href')); btn.removeAttribute('aria-busy'); }
        else btn.remove();
      }).catch(function () { window.location.href = url; });
    });
  }

  window.MH = { calc: calc, money: money, shippingFor: shippingFor, setNotice: setNotice, updateCartCount: updateCartCount };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-home-calc]').forEach(initHomeCalc);
    document.querySelectorAll('[data-buybox]').forEach(initBuyBox);
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-cart]').forEach(initCart);
    document.querySelectorAll('[data-load-more]').forEach(initLoadMore);
    initDrawer();
  });
})();
